module.exports = __webpack_public_path__ + "static/media/img-header-mob.bef5429d.jpg";